export default __webpack_public_path__ + "static/media/blog-2.c0756758.webp";